import { gql } from '~/src/generated/portal/gql';

const GET_API_VERSIONS = gql(`
  query getApiVersions {
    apiVersions {
      version
    }
  }
`);

export default GET_API_VERSIONS;
